import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-condiciones',
  templateUrl: './condiciones.component.html',
  styleUrls: ['./condiciones.component.css']
})
export class CondicionesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
